/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react'
import PropTypes from 'prop-types'
import {Stack, Fade, Text, Box} from '@salesforce/retail-react-app/app/components/shared/ui'
import useRegistrationFields from '../../components/forms/useRegistrationFields'
import Field from '../field'
import PasswordRequirements from '../../components/forms/password-requirements'
import {FormattedMessage} from 'react-intl'

const RegistrationFields = ({form, prefix = ''}) => {
    const fields = useRegistrationFields({form, prefix})
    const password = form.watch(`${prefix}password`)

    return (
        <Stack spacing={4}>
            <Stack spacing={4} pb={2}>
                <Field {...fields.email} />
                <Field {...fields.password} />
                {password?.length && (
                    <Fade in>
                        <PasswordRequirements value={password} />
                    </Fade>
                )}
                <Field {...fields.passwordConfirm} formControlProps={{mb: '28px'}} />
            </Stack>

            <Box>
                <Text
                    color="black"
                    fontSize="sm"
                    fontWeight="bold"
                    textTransform="uppercase"
                    mb="4"
                    lineHeight="16px"
                >
                    <FormattedMessage
                        id="login_want.more.from.your.garage.collectif"
                        defaultMessage="Want more from your Garage Collectif?"
                    />
                </Text>

                <Field {...fields.firstName} />
            </Box>
            <Field {...fields.lastName} />
            <Box>
                <Field {...fields.birthDay} />
                <Text fontSize="12px" fontWeight="400" pt="1" mb="3" lineHeight="15px">
                    <FormattedMessage
                        id="login_birthday.loyalty.gift"
                        defaultMessage="Add your birthday to get a special gift every year! You cannot change it afterwards."
                    />
                </Text>
            </Box>

            <Field {...fields.termsAndConditions} />
            <Field {...fields.emailSubscribe} />
        </Stack>
    )
}

RegistrationFields.propTypes = {
    /** Object returned from `useForm` */
    form: PropTypes.object.isRequired,

    /** Optional prefix for field names */
    prefix: PropTypes.string
}

export default RegistrationFields
